// extracted by mini-css-extract-plugin
module.exports = {"formDetails":"FormsOverviewListPanel_formDetails__HG45y","ingress":"FormsOverviewListPanel_ingress__Exqmt"};